import React from 'react';
import Grid from '@material-ui/core/Grid'
import { SelectInput, TextInput, ReferenceInput, required } from 'react-admin';

const ExemptionPolicyFields = props => (
  <React.Fragment>
    <Grid item xs={12} sm={6} >
      <TextInput source="name" validate={required()} {...props} />
    </Grid>
    <Grid item xs={12} sm={6} >
      <ReferenceInput source="schoolYearId" reference="schoolYears" validate={required()} allowEmpty {...props} >
        <SelectInput optionText="name"/>
      </ReferenceInput>
    </Grid>
  </React.Fragment>
)

export default ExemptionPolicyFields